module.exports = __webpack_public_path__ + "static/media/es.afe3cf77.webp";